import React from "react";
import { withNavBars } from "../../HOCs";
import { FolderView } from "./folderView";
import { useAppDispatch } from "../../redux";
import { closeDrawer, openDrawer } from "../../redux/slices/drawer";
import { History } from "../../components";

const DocumentsParent: React.FC<{ children?: JSX.Element }> = (props) => {

    const dispatch = useAppDispatch();

    const openDocumentHistory = (document_id: string) => {
        dispatch(openDrawer({
            title: "Document History",
            btnName: "Close",
            component: <History variant="document" document_id={document_id} />,
            onSave: () => dispatch(closeDrawer())
        }))
    };

    return (
        <FolderView openDocumentHistory={openDocumentHistory} />
    );
}

export default withNavBars(DocumentsParent);